"use strict";
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-underscore-dangle */
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazy = void 0;
/**
 * Converts a get property to a lazy get property.  Lazy properties compute and cache their value at the point they are first
 * read and on subsequent calls return the cached value.
 */
var lazy = function () {
    return function (_target, key, descriptor) {
        var getter = descriptor.get;
        // tslint:disable-next-line: only-arrow-functions
        descriptor.get = function () {
            var value = getter.call(this);
            Object.defineProperty(this, key, {
                configurable: true,
                enumerable: true,
                writable: false,
                value: value,
            });
            return value;
        };
        return descriptor;
    };
};
exports.lazy = lazy;
